import { Typography } from "@mui/material";
import BasicButton from "../../../ui library/components/buttons/BasicButton";

export default function DeleteReferralDialogue({ title, onClickDelete }) {
  return (
    <div className="flex flex-col items-center h-full w-full p-2">
      <div className="p-4">
        <Typography className="text-red-600 text-lg font-bold">
          {title}
        </Typography>
      </div>
      <div className="p-4">
        <Typography className="text-black text-normal">
          Are you sure you want to delete the selected referrals?
        </Typography>
      </div>
      <div className="flex flex-row gap-2">
        <BasicButton
          disabled={false}
          text="Proceed to Delete"
          className={`bg-red-600 hover:bg-red-700`}
          onClick={onClickDelete}
        />
      </div>
    </div>
  );
}
